import React, {Component} from 'react'

import style from './description.sass'

class Description extends Component {
  render() {
    return(
      <section className='bg-white'>
        <div className='landing-container' styleName='description'>
          <p>
            Algoriz is an AI that allows you to quickly build, backtest and automate trading strategies in Equities and Cryptocurrencies..
          </p>
          <div styleName='logos'>
            <div styleName='img-container'>
              <img src='/img/landing/home/logo-1.png' alt=''/>
            </div>
            <div styleName='img-container'>
              <img src='/img/landing/home/logo-2.png' alt=''/>
            </div>
            <div styleName='img-container'>
              <img src='/img/landing/home/logo-3.png' alt=''/>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default Description
